import WorkInformation from './WorkInformation';

export default WorkInformation;
